import { useIntl } from "react-intl";
import { handleImageLink } from "@/helpers/functions";
import SvgComponent from "@/components/Shared/SvgComponent";

const Card = ({ item }) => {
  const { locale } = useIntl();

  return (
    <div className="card-item">
      <div className="icon flex-center">
        <SvgComponent
          src={handleImageLink(item?.icon)}
          // fillColor={isHovered ? "#FF5733" : "#233654"}
          fillColor="#233654"
        />
      </div>
      <div className="content">
        <h3>{item?.title?.[locale]}</h3>
        <p>{item?.description?.[locale]}</p>
      </div>
    </div>
  );
};

export default Card;
